export default {
  token: 'ust',
  isLogin: 'ls',
  user: 'u',
};
